export function hexToRGB(hex, alpha) {
  var r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16)

  if (alpha) {
    return [r, g, b, alpha]
  } else {
    return [r, g, b]
  }
}

export function getForegroundColor(hex) {
  const [r, g, b] = hexToRGB(hex)
  return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? 'black' : 'white'
}
